import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Button from '../Button';

/*
The NoticeDialog component is used to pop notices to the user which needs
to get the user attention. To achive this goal, the component, when pop to the
page, will present the iputed message and will only close by the user clicking the OK button.
Example can be notice for wronge file type input or need to upload picture before pushing edite button.

For messages that do not demand the user attention, use enqueueSnackbar.
Example can be success message for different operetions.
*/
function NoticeDialog(props) {
  const {
    open,
    onOkClick,
    noticeTitle,
    message,
    classes: {
      modal,
      modalContent,
      button,
      title,
    },
  } = props;

  return (
    <Dialog 
      maxWidth = {'md'}
      open={open}
      // disableBackdropClick
      onClose={onOkClick}
      classes={{ paper: modal }}
    >
      <DialogTitle className={title}>{noticeTitle}</DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        {message}
      </DialogContent> 
      <Button
          onClick={onOkClick}
          variant="contained"
          color="primary"
          className={button}
        >
          ok
        </Button>
    </Dialog>
  );
}

NoticeDialog.propTypes = {
  onOkClick: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
    marginBottom: '10px',
  },
  button: {
    maxWidth: '50px',
    margin: 'auto',
    marginBottom: '10px',
  },
  title: {
    marginTop: '10px',
    marginLeft: '10px',
    padding: '5px',
  },
});

export default withStyles(styles)(NoticeDialog);
